import styled, { css } from 'styled-components';

export const moduleOutlineMixin = css`
  outline-width: 2px;
  outline-color: ${({ theme }) => theme.color.primary.brand600};
  // -0.5px offset will cause adjacent 1px outlines to overlap perfectly
  outline-offset: -1px;
`;

export const ModulePreview = styled('div')<{ hidden?: boolean }>`
  display: ${({ hidden }) => (hidden ? 'none' : 'block')};
  background-color: ${({ theme }) => theme.color.primary.brand400};
  opacity: 0.3;
  width: 100%;
  height: 100%;

  border-radius: ${({ theme }) => {
    return theme.card.borderRadius;
  }};
`;
